const colours = {
    red: '#9c421f',
    offWhite: '#f1eee5',
    cyclus: '#e6e2d7',
    blue: '#1d68a6'
}

export default colours
